(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-vcc-side-menu]';
  var MAIN_STYLE_READY = 'vcc-side-menu-main-style-ready';
  var SCORE_STYLE_READY = 'vcc-side-menu-scoreboard-style-ready';
  var jobs = window.__vccSideMenuBootstrapJobs || {
    styles: Object.create(null),
    scripts: Object.create(null)
  };
  window.__vccSideMenuBootstrapJobs = jobs;

  function getCornerScrollTop(scrollSource) {
    var scrollSourceTop = 0;

    if (scrollSource && document.documentElement.contains(scrollSource)) {
      scrollSourceTop = scrollSource.scrollTop || 0;
    }

    return Math.max(
      window.scrollY || window.pageYOffset || 0,
      document.documentElement ? document.documentElement.scrollTop || 0 : 0,
      document.body ? document.body.scrollTop || 0 : 0,
      document.scrollingElement ? document.scrollingElement.scrollTop || 0 : 0,
      scrollSourceTop
    );
  }

  function getCornerMorphDistance(section) {
    var morphDistance = parseInt(section.getAttribute('data-vcc-corner-scroll-distance'), 10);
    return isNaN(morphDistance) ? 72 : morphDistance;
  }

  function initCornerScrollMorph(section) {
    if (section.dataset.vccCornerScrollReady === 'true') {
      section.dispatchEvent(new CustomEvent('vcc:corner-morph-refresh'));
      return;
    }

    section.dataset.vccCornerScrollReady = 'true';

    var morphTicking = false;
    var morphScrollSource = null;
    var observer = null;

    function teardown() {
      window.removeEventListener('scroll', requestCornerMorph);
      window.removeEventListener('resize', requestCornerMorph);
      document.removeEventListener('scroll', requestCornerMorph, true);
      section.removeEventListener('vcc:corner-morph-refresh', requestCornerMorph);
      if (observer) {
        observer.disconnect();
      }
    }

    function updateCornerMorph() {
      morphTicking = false;
      if (!document.documentElement.contains(section)) {
        teardown();
        return;
      }

      var enabled = section.hasAttribute('data-vcc-corner-scroll-morph');
      if (morphScrollSource && !document.documentElement.contains(morphScrollSource)) {
        morphScrollSource = null;
      }
      var currentScrollTop = getCornerScrollTop(morphScrollSource);
      section.classList.toggle('is-corner-morphed', enabled && currentScrollTop > getCornerMorphDistance(section));
    }

    function requestCornerMorph(event) {
      if (event && event.target && event.target !== document && event.target !== window) {
        var target = event.target;
        var targetCanScroll = target.scrollHeight && target.clientHeight && target.scrollHeight > target.clientHeight + 1;
        var targetScrollTop = target.scrollTop || 0;

        if (targetCanScroll && (targetScrollTop > 0 || target === morphScrollSource)) {
          morphScrollSource = target;
        }
      } else if (event && (event.target === document || event.target === window)) {
        morphScrollSource = null;
      }

      if (morphTicking) return;
      morphTicking = true;
      window.requestAnimationFrame(updateCornerMorph);
    }

    window.addEventListener('scroll', requestCornerMorph, { passive: true });
    window.addEventListener('resize', requestCornerMorph);
    document.addEventListener('scroll', requestCornerMorph, true);
    section.addEventListener('vcc:corner-morph-refresh', requestCornerMorph);

    if (window.MutationObserver) {
      observer = new MutationObserver(requestCornerMorph);
      observer.observe(section, {
        attributes: true,
        attributeFilter: ['data-vcc-corner-scroll-morph', 'data-vcc-corner-scroll-distance']
      });
    }

    requestCornerMorph();
  }

  function resolved(value) {
    return Promise.resolve(value);
  }

  function setFetchPriority(node, priority) {
    if (!node || !priority) return;
    if ('fetchPriority' in node) node.fetchPriority = priority;
    else node.setAttribute('fetchpriority', priority);
  }

  function prioritizeExisting(selector, url, priority) {
    if (!url) return;
    var absolute = new URL(url, document.baseURI).href;
    var node = Array.prototype.find.call(document.querySelectorAll(selector), function (candidate) {
      return candidate.href === absolute || candidate.src === absolute;
    });
    setFetchPriority(node, priority);
  }

  function stylesheet(url, kind, readyClass, priority) {
    if (!url || document.documentElement.classList.contains(readyClass)) return resolved(true);
    if (jobs.styles[url]) {
      if (priority === 'high') {
        var activeLink = Array.prototype.find.call(document.querySelectorAll('link[rel="stylesheet"]'), function (candidate) {
          return candidate.href === new URL(url, document.baseURI).href;
        });
        setFetchPriority(activeLink, 'high');
      }
      return jobs.styles[url];
    }

    jobs.styles[url] = new Promise(function (resolve, reject) {
      var link = Array.prototype.find.call(document.querySelectorAll('link[rel="stylesheet"]'), function (candidate) {
        return candidate.href === new URL(url, document.baseURI).href;
      });
      if (link && link.getAttribute('data-vcc-side-menu-runtime-failed') === 'true') {
        if (link.hasAttribute('data-vcc-side-menu-runtime-style')) link.remove();
        link = null;
      }
      var settled = false;

      function finish() {
        if (settled) return;
        settled = true;
        document.documentElement.classList.add(readyClass);
        resolve(true);
      }

      function fail() {
        if (settled) return;
        settled = true;
        delete jobs.styles[url];
        link.setAttribute('data-vcc-side-menu-runtime-failed', 'true');
        if (link.hasAttribute('data-vcc-side-menu-runtime-style')) link.remove();
        reject(new Error('Side Menu ' + kind + ' stylesheet failed'));
      }

      var created = false;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.setAttribute('data-vcc-side-menu-runtime-style', kind);
        created = true;
      }
      setFetchPriority(link, priority || 'high');

      link.addEventListener('load', finish, { once: true });
      link.addEventListener('error', fail, { once: true });
      if (created) document.head.appendChild(link);
      if (link.sheet) finish();
    });

    return jobs.styles[url];
  }

  function script(url, kind, readyTest, priority) {
    if (!url || readyTest()) return resolved(true);
    if (jobs.scripts[url]) {
      if (priority === 'high') {
        var activeScript = Array.prototype.find.call(document.scripts, function (candidate) {
          return candidate.src === new URL(url, document.baseURI).href;
        });
        setFetchPriority(activeScript, 'high');
      }
      return jobs.scripts[url];
    }

    jobs.scripts[url] = new Promise(function (resolve, reject) {
      var absolute = new URL(url, document.baseURI).href;
      var node = Array.prototype.find.call(document.scripts, function (candidate) {
        return candidate.src === absolute;
      });
      if (node && node.getAttribute('data-vcc-side-menu-runtime-failed') === 'true') {
        if (node.hasAttribute('data-vcc-side-menu-runtime-script')) node.remove();
        node = null;
      }
      var settled = false;

      function finish() {
        if (settled) return;
        if (!readyTest()) {
          fail();
          return;
        }
        settled = true;
        resolve(true);
      }

      function fail() {
        if (settled) return;
        settled = true;
        delete jobs.scripts[url];
        node.setAttribute('data-vcc-side-menu-runtime-failed', 'true');
        if (node.hasAttribute('data-vcc-side-menu-runtime-script')) node.remove();
        reject(new Error('Side Menu ' + kind + ' script failed'));
      }

      var created = false;
      if (!node) {
        node = document.createElement('script');
        node.src = url;
        node.async = true;
        node.setAttribute('data-vcc-side-menu-runtime-script', kind);
        created = true;
      }
      setFetchPriority(node, priority || 'high');

      node.addEventListener('load', finish, { once: true });
      node.addEventListener('error', fail, { once: true });
      if (created) document.head.appendChild(node);
      if (readyTest()) finish();
    });

    return jobs.scripts[url];
  }

  function mainReady(root) {
    return root.getAttribute('data-vcc-side-main-ready') === 'true' &&
      document.documentElement.classList.contains(MAIN_STYLE_READY) &&
      typeof window.VccInitSideMenu === 'function';
  }

  function scoreboardReady(root) {
    return root.getAttribute('data-vcc-side-scoreboard-ready') === 'true' &&
      document.documentElement.classList.contains(SCORE_STYLE_READY) &&
      Boolean(window.VCCSideMenuScoreboard);
  }

  function ensureMain(root, priority) {
    if (mainReady(root)) return resolved(true);
    if (priority === 'high') root.__vccSideMenuRequestedPriority = 'high';
    if (root.__vccSideMenuMainPromise) {
      if (priority === 'high') {
        prioritizeExisting('link[rel="stylesheet"]', root.getAttribute('data-vcc-side-main-style-url'), 'high');
        prioritizeExisting('script', root.getAttribute('data-vcc-side-overlay-script-url'), 'high');
        prioritizeExisting('script', root.getAttribute('data-vcc-side-main-script-url'), 'high');
      }
      return root.__vccSideMenuMainPromise;
    }

    var requestedPriority = priority === 'low' ? 'low' : 'high';
    root.__vccSideMenuRequestedPriority = requestedPriority;
    root.setAttribute('data-vcc-side-main-state', 'loading');
    var mainRuntime = script(root.getAttribute('data-vcc-side-overlay-script-url'), 'overlay lock', function () {
      return Boolean(window.VccOverlayLock);
    }, requestedPriority).then(function () {
      return script(root.getAttribute('data-vcc-side-main-script-url'), 'main', function () {
        return typeof window.VccInitSideMenu === 'function';
      }, root.__vccSideMenuRequestedPriority || requestedPriority);
    });
    root.__vccSideMenuMainPromise = Promise.all([
      stylesheet(root.getAttribute('data-vcc-side-main-style-url'), 'main', MAIN_STYLE_READY, requestedPriority),
      mainRuntime
    ]).then(function () {
      if (typeof window.VccInitSideMenu === 'function') window.VccInitSideMenu(root);
      root.setAttribute('data-vcc-side-main-ready', 'true');
      root.setAttribute('data-vcc-side-main-state', 'ready');
      window.__vccSideMenuShellReady = true;
      document.dispatchEvent(new CustomEvent('vcc:side-menu-shell-ready'));
      return true;
    }).catch(function (error) {
      root.__vccSideMenuMainPromise = null;
      root.setAttribute('data-vcc-side-main-state', 'error');
      throw error;
    });

    return root.__vccSideMenuMainPromise;
  }

  function ensureScoreboard(root) {
    if (root.getAttribute('data-vcc-league-overview') !== 'scoreboard') return resolved(true);
    if (scoreboardReady(root)) return resolved(true);
    if (root.__vccSideMenuScorePromise) return root.__vccSideMenuScorePromise;

    root.setAttribute('data-vcc-side-scoreboard-state', 'loading');
    root.__vccSideMenuScorePromise = Promise.all([
      stylesheet(root.getAttribute('data-vcc-side-scoreboard-style-url'), 'scoreboard', SCORE_STYLE_READY),
      script(root.getAttribute('data-vcc-side-scoreboard-script-url'), 'scoreboard', function () {
        return Boolean(window.VCCSideMenuScoreboard);
      })
    ]).then(function () {
      if (window.VCCSideMenuScoreboard && typeof window.VCCSideMenuScoreboard.init === 'function') {
        window.VCCSideMenuScoreboard.init(root);
      }
      root.setAttribute('data-vcc-side-scoreboard-ready', 'true');
      root.setAttribute('data-vcc-side-scoreboard-state', 'ready');
      return true;
    }).catch(function (error) {
      root.__vccSideMenuScorePromise = null;
      root.setAttribute('data-vcc-side-scoreboard-state', 'error');
      throw error;
    });

    return root.__vccSideMenuScorePromise;
  }

  function connectionIsConstrained() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return Boolean(connection && (connection.saveData === true || /(^|-)2g$/i.test(connection.effectiveType || '')));
  }

  function activePicture(link, theme) {
    var media = link.querySelector('.vcc-side-menu__link-media');
    if (!media) return null;
    if (theme === 'light' && media.classList.contains('vcc-side-menu__link-media--has-light')) {
      return media.querySelector('picture[data-vcc-side-critical-picture="light"]');
    }
    return media.querySelector('picture[data-vcc-side-critical-picture="default"]');
  }

  function hydratePicture(picture, priority) {
    if (!picture) return;
    picture.querySelectorAll('source').forEach(function (source) {
      var srcset = source.getAttribute('data-vcc-side-srcset');
      var src = source.getAttribute('data-vcc-side-src');
      if (srcset) source.setAttribute('srcset', srcset);
      if (src) source.setAttribute('src', src);
      source.removeAttribute('data-vcc-side-srcset');
      source.removeAttribute('data-vcc-side-src');
    });
    var image = picture.querySelector('img');
    if (!image) return;
    var imageSrcset = image.getAttribute('data-vcc-side-srcset');
    var imageSrc = image.getAttribute('data-vcc-side-src');
    if (imageSrcset) image.setAttribute('srcset', imageSrcset);
    if (imageSrc) image.setAttribute('src', imageSrc);
    image.removeAttribute('data-vcc-side-srcset');
    image.removeAttribute('data-vcc-side-src');
    image.loading = 'eager';
    image.decoding = 'async';
    if ('fetchPriority' in image) image.fetchPriority = priority || 'low';
  }

  function warmCritical(root, intent) {
    if ((!intent && connectionIsConstrained()) || root.getAttribute('data-vcc-side-bootstrap-warmed') === 'true') return;
    if (!document.documentElement.contains(root) || (!intent && document.hidden)) return;
    root.setAttribute('data-vcc-side-bootstrap-warmed', 'true');

    var priority = intent ? 'high' : 'low';
    var theme = document.documentElement.getAttribute('data-vcc-theme') === 'dark' ? 'dark' : 'light';
    var background = root.getAttribute(theme === 'dark' ? 'data-vcc-panel-background-dark' : 'data-vcc-panel-background-light');
    if (background) {
      var image = new Image();
      image.decoding = 'async';
      if ('fetchPriority' in image) image.fetchPriority = priority;
      image.src = background;
      root.__vccSideMenuWarmImages = root.__vccSideMenuWarmImages || [];
      root.__vccSideMenuWarmImages.push(image);
    }
    Array.prototype.slice.call(root.querySelectorAll('.vcc-side-menu__links > .vcc-side-menu__link'), 0, 4)
      .forEach(function (link) { hydratePicture(activePicture(link, theme), priority); });
  }

  function warmInteractiveAfterFirstPaint(root) {
    function canWarm() {
      return !connectionIsConstrained() && !document.hidden && document.documentElement.contains(root);
    }

    function warmInteractiveShell() {
      if (!canWarm()) return;
      ensureMain(root, 'low').catch(function () {});
    }

    function warmVisuals() {
      if (!canWarm()) return;
      warmCritical(root, false);
    }

    function scheduleVisuals() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(warmVisuals, { timeout: 1600 });
          } else {
            window.setTimeout(warmVisuals, 180);
          }
        });
      });
    }

    function scheduleVisualsAfterHero() {
      if (
        window.__vccFirstHeroPainted === true
        || (window.VCCFirstHeroPaint && window.VCCFirstHeroPaint.painted === true)
        || document.documentElement.dataset.vccFirstHeroPainted === 'true'
      ) {
        scheduleVisuals();
        return;
      }
      document.addEventListener('vcc:first-hero-painted', scheduleVisuals, { once: true });
    }

    function schedule() {
      // The 33KB compressed interaction shell gets a quiet head start as soon
      // as this tiny bootstrap is ready. Panel imagery still waits until after
      // the first hero so it cannot compete with the page's LCP image.
      window.requestAnimationFrame(warmInteractiveShell);
      scheduleVisualsAfterHero();
    }

    function scheduleWhenVisible() {
      if (!document.hidden) {
        schedule();
        return;
      }
      document.addEventListener('visibilitychange', function onVisible() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVisible);
        schedule();
      });
    }

    scheduleWhenVisible();
  }

  function withTimeout(promise, milliseconds) {
    return Promise.race([
      Promise.resolve(promise).catch(function () { return false; }),
      new Promise(function (resolve) { window.setTimeout(function () { resolve(false); }, milliseconds); })
    ]);
  }

  function prepareFirstOpen(root) {
    if (typeof root.__vccSideMenuPrepare !== 'function') return resolved(true);
    return withTimeout(root.__vccSideMenuPrepare(), 1800);
  }

  function stopActivation(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function setBusy(control, busy) {
    if (!control) return;
    if (busy) {
      control.setAttribute('aria-busy', 'true');
    } else {
      control.removeAttribute('aria-busy');
    }
  }

  function replay(root, control) {
    if (!control || !document.documentElement.contains(control)) return;
    root.__vccSideMenuBootstrapReplay = true;
    setBusy(control, false);
    control.click();
    window.setTimeout(function () { root.__vccSideMenuBootstrapReplay = false; }, 0);
  }

  function isScoreboardControl(root, target) {
    if (root.getAttribute('data-vcc-league-overview') !== 'scoreboard' || !target || !target.closest) return null;
    var control = target.closest('[data-vcc-side-scoreboard-intent], [data-vcc-league-open]');
    return control && root.contains(control) ? control : null;
  }

  function attach(root) {
    if (!root) return;
    initCornerScrollMorph(root);
    if (root.getAttribute('data-vcc-side-bootstrap-ready') === 'true') return;
    root.setAttribute('data-vcc-side-bootstrap-ready', 'true');

    function anticipate(event) {
      if (!event.target || !event.target.closest) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      var toggle = event.target.closest('[data-vcc-side-menu-toggle]');
      if (toggle && root.contains(toggle)) {
        warmCritical(root, true);
        ensureMain(root, 'high').catch(function () {});
      }
      if (isScoreboardControl(root, event.target)) ensureScoreboard(root).catch(function () {});
    }

    function activate(event) {
      if (root.__vccSideMenuBootstrapReplay || event.defaultPrevented || event.button !== 0) return;
      var toggle = event.target && event.target.closest ? event.target.closest('[data-vcc-side-menu-toggle]') : null;
      var scoreboardControl = isScoreboardControl(root, event.target);

      if (toggle && root.contains(toggle) && !mainReady(root)) {
        stopActivation(event);
        if (root.__vccSideMenuMainActivationPending) return;
        root.__vccSideMenuMainActivationPending = true;
        setBusy(toggle, true);
        ensureMain(root, 'high')
          .then(function () { return prepareFirstOpen(root); })
          .then(function () {
            root.__vccSideMenuMainActivationPending = false;
            replay(root, toggle);
          })
          .catch(function () {
            root.__vccSideMenuMainActivationPending = false;
            setBusy(toggle, false);
          });
        return;
      }

      if (scoreboardControl && !scoreboardReady(root)) {
        stopActivation(event);
        if (root.__vccSideMenuScoreActivationPending) return;
        root.__vccSideMenuScoreActivationPending = true;
        setBusy(scoreboardControl, true);
        Promise.all([ensureMain(root, 'high'), ensureScoreboard(root)])
          .then(function () {
            root.__vccSideMenuScoreActivationPending = false;
            replay(root, scoreboardControl);
          })
          .catch(function () {
            root.__vccSideMenuScoreActivationPending = false;
            setBusy(scoreboardControl, false);
          });
      }
    }

    ['pointerover', 'pointerdown', 'focusin', 'keydown'].forEach(function (name) {
      root.addEventListener(name, anticipate, true);
    });
    root.addEventListener('touchstart', anticipate, { capture: true, passive: true });
    root.addEventListener('click', activate, true);
    warmInteractiveAfterFirstPaint(root);

    var marker = window.history && window.history.state && window.history.state.vccSideMenu;
    if (marker && marker.owner && String(marker.owner).indexOf('vcc-side-menu:') === 0) {
      var serializedPath = '';
      try { serializedPath = JSON.stringify(marker.path || ''); } catch (error) {}
      var load = serializedPath.indexOf('fan-zone') !== -1
        ? ensureMain(root, 'high').then(function () { return ensureScoreboard(root); })
        : ensureMain(root, 'high');
      load.catch(function () {});
    }
  }

  function scan(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) attach(target);
    target.querySelectorAll(ROOT_SELECTOR).forEach(attach);
  }

  if (!window.VCCSideMenuBootstrap) {
    window.VCCSideMenuBootstrap = {
      scan: scan,
      ensureMain: ensureMain,
      ensureScoreboard: ensureScoreboard
    };
    scan(document);
    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target || document);
    });
  } else if (typeof window.VCCSideMenuBootstrap.scan === 'function') {
    window.VCCSideMenuBootstrap.scan(document);
  }
})();
